var get           = require("object-path").get,
    quickMacroize = require("enyo/macroize").quickMacroize,
    transformBookmark,
    transformContentItem;

/**
 * Takes raw incoming data from the API and applies some extra sugar.
 *
 * @param    {string}  language   The current application language
 * @param    {Object}  bookmarks  The bookmarks data
 * @returns  {Object}  The transformed data
 * @public
 */
exports.transformBookmarks = function(language, bookmarks) {
    bookmarks = bookmarks || [];
    bookmarks
        .map(function(bookmark) {
            return transformBookmark(language, bookmark);
        });

    return bookmarks;
};

/**
 * Takes raw incoming data from the API and applies some extra sugar.
 *
 * @param    {string}  language  The current application language
 * @param    {Object}  bookmark  The bookmark data
 * @returns  {Object}  The transformed data
 * @public
 */
transformBookmark = function(language, bookmark) {
    bookmark.media_item = transformContentItem(language, bookmark.media_item);

    return bookmark;
};

/**
 * Adds links to content item.
 *
 * @param    {string}  language  The current application language
 * @param    {Object}  content   The content data
 * @returns  {Object}  The transformed data
 * @public
 */
transformContentItem = function(language, content) {
    // Add links
    switch (content.type) {
        case "album_track":
        case "audio":
        case "book":
        case "episode":
        case "issue":
        case "podcast_episode":
        case "video":
            content.links.details = quickMacroize("/{$language}/bookmarks/{$mediaType}/{$mediaSlug}", {
                language:  language,
                mediaType: content.type.replaceAll("_", "-"),
                mediaSlug: get(content, "meta.slug", null)
            });
            break;
        case "brand":
        case "category":
        case "external":
        case "magazine":
        case "music_album":
        case "page":
        case "photo":
        case "podcast":
        case "product":
        case "product_category":
        case "series":
        default:
            break;
    }

    return content;
};
